import { render, staticRenderFns } from "./AnnualLicensePayment.vue?vue&type=template&id=04cc2481&scoped=true"
import script from "./AnnualLicensePayment.vue?vue&type=script&lang=js"
export * from "./AnnualLicensePayment.vue?vue&type=script&lang=js"
import style0 from "./AnnualLicensePayment.vue?vue&type=style&index=0&id=04cc2481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc2481",
  null
  
)

export default component.exports